import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import {
	getLabelColorByStateAndDifficulty,
	getTrackColorByStateAndDifficulty
} from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";

const Track7ABlue = ({ state, workState, onLabelClick }) => (
	<g id="Track7ABlue" transform="translate(1461.000000, 948.000000)" className="track">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round" strokeWidth={tracksWidth}
		>
			<path
				d="M9.9475983e-14,5.68434189e-14 C11.2818345,6.31942278 20.8689647,15.2722567 27.9446655,26.0958121 L113.743509,157.340555 L113.743509,157.340555"/>
			<line x1="194" y1="262.027411" x2="147.149414" y2="202.162229" id="Path"/>
			<line x1="147.149414" y1="202.162229" x2="120" y2="168" id="Path"/>
			<polyline id="arrow" strokeLinejoin="round"
								transform="translate(121.323478, 169.870995) rotate(-307.000000) translate(-121.323478, -169.870995) "
								points="125.323478 177.870995 117.323478 169.870995 125.323478 161.870995"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track7ABlue')}
			coords="64.000000, 88.030343"
			text='7A'
			textCoordsX={'10.8232422'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track7ABlue.propTypes = trackPropTypes;

export default Track7ABlue;
